export * from './IconDocumentSearchGradient';
export { default as IconDocumentSearchGradient } from './IconDocumentSearchGradient';
